import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../../tailwind.config';

export const CrmActivityTask: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['white'], background = theme.colors['yellow-advert'] }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill={background} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6665 15L21.6665 15V16.6667L11.6665 16.6667V15ZM11.6665 18.3333L21.6665 18.3333V20L11.6665 20L11.6665 18.3333ZM11.6665 23.3333H18.3332V21.6667H11.6665V23.3333ZM29.1665 20.8333L27.9165 19.5833L23.3415 24.1667L20.8332 21.6667L19.5832 22.9167L23.3415 26.6667L29.1665 20.8333Z"
        fill={fill}
      />
    </svg>
  )
);
